import React from 'react';
import { Link } from 'react-router-dom';
interface LogoProps {
  className?: string;
  size?: 'small' | 'large';
}
export const Logo: React.FC<LogoProps> = ({
  className = '',
  size = 'large'
}) => {
  return <Link to="/" className={`flex items-center ${className}`} data-id="element-157">
      <div className="mr-2" data-id="element-158">
        <svg width={size === 'small' ? '24' : '32'} height={size === 'small' ? '24' : '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-159">
          <rect width="32" height="32" rx="4" fill="black" data-id="element-160" />
          <path d="M16 6L16 26" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-161" />
          <path d="M6 16L26 16" stroke="#E11D48" strokeWidth="2" strokeLinecap="round" data-id="element-162" />
        </svg>
      </div>
      <div className={`font-bold ${size === 'small' ? 'text-sm' : 'text-xl'} tracking-wider text-black`} data-id="element-163">
        DEBT RESCUE
      </div>
    </Link>;
};